import React from 'react';
import Icon from '@/components/ui/icon-map';
import { FEATURES } from '@/constants/app';
import FeatureCard from '@/components/ui/feature-card';
import SectionHeader from '@/components/ui/section-header';

/**
 * Features section showcasing app capabilities
 */
const Features = () => {
  return (
    <section id="features" className="section bg-white py-20">
      <div className="max-w-7xl mx-auto">
        <SectionHeader
          badge="Comprehensive Medication Management"
          title="Features Designed for Better Medication Management"
          description="Meduler is more than just a pill reminder app. Our complete set of medication tracking and management tools help you stay on top of your health."
          className="mb-16 opacity-0 animate-fade-in"
        />
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {FEATURES.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              animationDelay={feature.delay}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
